import { render, staticRenderFns } from "./Hotline.vue?vue&type=template&id=0e998234&scoped=true&"
import script from "./Hotline.vue?vue&type=script&lang=js&"
export * from "./Hotline.vue?vue&type=script&lang=js&"
import style0 from "./Hotline.vue?vue&type=style&index=0&id=0e998234&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e998234",
  null
  
)

export default component.exports